'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _doctifyFiveStarRating = require('./doctify-five-star-rating');

var _doctifyFiveStarRating2 = _interopRequireDefault(_doctifyFiveStarRating);

var _doctifyReviewBadge = require('../../src/styles/doctify-review-badge.scss');

var _doctifyReviewBadge2 = _interopRequireDefault(_doctifyReviewBadge);

var _logo = require('../../src/img/logo.svg');

var _logo2 = _interopRequireDefault(_logo);

var _appleHalf = require('../../src/img/apple-half.png');

var _appleHalf2 = _interopRequireDefault(_appleHalf);

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
	'div',
	null,
	'verified by'
);

var DoctifyReviewBadge = function (_React$Component) {
	(0, _inherits3.default)(DoctifyReviewBadge, _React$Component);

	function DoctifyReviewBadge(props) {
		(0, _classCallCheck3.default)(this, DoctifyReviewBadge);
		return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	}

	DoctifyReviewBadge.prototype.render = function render() {
		var _props = this.props,
		    averageRating = _props.averageRating,
		    totalReviews = _props.totalReviews,
		    profileURI = _props.profileURI;
		// Rounds average rating to one decimal place.

		averageRating = totalReviews ? Math.round(averageRating * 10) / 10 : 0;

		return _react2.default.createElement(
			'div',
			{ className: _doctifyReviewBadge2.default.badgeContainer },
			_react2.default.createElement('img', { className: _doctifyReviewBadge2.default.apple, src: _appleHalf2.default }),
			_react2.default.createElement(
				'a',
				{
					href: profileURI,
					target: '_blank',
					rel: 'nofollow noopener'
				},
				_react2.default.createElement(
					'div',
					{ className: _doctifyReviewBadge2.default.header },
					_ref,
					_react2.default.createElement('img', { className: _doctifyReviewBadge2.default.logo, src: _logo2.default })
				),
				_react2.default.createElement(
					'div',
					{ className: _doctifyReviewBadge2.default.starsContainer },
					_react2.default.createElement(_doctifyFiveStarRating2.default, { rating: averageRating })
				),
				_react2.default.createElement(
					'div',
					{ className: _doctifyReviewBadge2.default.reviewsContainer },
					_react2.default.createElement(
						'span',
						{ className: _doctifyReviewBadge2.default.averageRating },
						averageRating
					),
					_react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _defaultMessages2.default.totalReviews, { values: { totalReviews: totalReviews } }))
				)
			)
		);
	};

	return DoctifyReviewBadge;
}(_react2.default.Component);

exports.default = DoctifyReviewBadge;


DoctifyReviewBadge.displayName = 'DoctifyReviewBadge';

DoctifyReviewBadge.defaultProps = {
	averageRating: 0,
	totalReviews: 0,
	profileURI: '//www.doctify.co.uk'
};